import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";

import { uniq, flatten, values } from "lodash";
import { Loader } from "semantic-ui-react";

import {
    PhysiotherapyReferralReportV2
} from "@teamprevent/common/physiotherapyReferralReport/components/PhysiotherapyReferralReportV2";
import {
    PhysiotherapyReferralReportDetails,
    PhysiotherapyReferralReportModel,
    PHYSIOTHERAPY_REFERRAL_REPORT_KEY
} from "@teamprevent/common/physiotherapyReferralReport/models";
import { QuestionnairesState } from "@teamprevent/common/questionnaires/model";
import { ConsultationDetails } from "@teamprevent/common/model";

import { physiotherapyReferralReportApi } from "../../physiotherapyReferralReports/physiotherapyReferralReportApi";
import { loadPhysiotherapyReferralReportByWriteTaskId, loadPhysiotherapyReferralReportByViewTaskId } from "../../physiotherapyReferralReports/actions";

import { Location } from "redux-little-router";

export const PhysiotherapyReportDetailV2: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [consultationAndReferralDetails, setConsultationAndReferralDetails] = React.useState<ConsultationDetails>(null);
    const [reportDetails, setReportDetails] = React.useState<PhysiotherapyReferralReportDetails>(null);

    const questions = useSelector((state: { questionnaires: QuestionnairesState }) =>
        uniq(flatten(state.questionnaires[PHYSIOTHERAPY_REFERRAL_REPORT_KEY]?.sections?.map(section => values(section.questions)))));
    const eTag = useSelector((state: { questionnaires: QuestionnairesState }) => state.questionnaires[PHYSIOTHERAPY_REFERRAL_REPORT_KEY]?.eTag);
    const report: PhysiotherapyReferralReportModel = { questions, eTag };
    const ohCaseId = useSelector((state: { router: Location }) => state.router.params?.ohCaseId);
    const writeReportTaskId = useSelector((state: { router: Location }) => state.router.params?.writeReportTaskId);
    const viewReportTaskId = useSelector((state: { router: Location }) => state.router.params?.viewReportTaskId);

    const loadQuestionnaire = () => {
        (async () => {
            if (writeReportTaskId) {
                dispatch(loadPhysiotherapyReferralReportByWriteTaskId({ ohCaseId, writeReportTaskId }));
                const details = await physiotherapyReferralReportApi.getConsultationDetailsByWriteTaskId(ohCaseId, writeReportTaskId);
                setConsultationAndReferralDetails(details);
            } else if (viewReportTaskId) {
                dispatch(loadPhysiotherapyReferralReportByViewTaskId({ ohCaseId, viewReportTaskId }));
                const details = await physiotherapyReferralReportApi.getConsultationDetailsByViewTaskId(ohCaseId, viewReportTaskId);
                setConsultationAndReferralDetails(details);
            }
        })();
    };

    React.useEffect(() => {
        if (ohCaseId && (writeReportTaskId || viewReportTaskId)) {
            loadQuestionnaire();
        }

        (async () => {
            const details = await physiotherapyReferralReportApi.getReportDetails(ohCaseId, writeReportTaskId, viewReportTaskId);
            setReportDetails(details);
        })();
    }, [ohCaseId, writeReportTaskId, viewReportTaskId]);

    if (!consultationAndReferralDetails || !reportDetails) {
        return <Loader active />;
    }

    return (
        <PhysiotherapyReferralReportV2
            readonly={true}
            loading={false}
            customerId={null}
            ohCaseId={null}
            taskId={null}
            ohCase={null}
            employeeRecord={null}
            report={report}
            consultationAndReferralDetails={consultationAndReferralDetails}
            loadQuestionnaire={() => null}
            submitQuestionnaire={() => null}
            updateAnswer={() => null}
            loadEmployee={() => null}
            loadConsultationDetails={() => null}
            saveReport={() => null}
            clearQuestionnaire={() => null}
            onCompletion={() => null}
            submitInvalidQuestionnaire={() => null}
            extraSections={null}
            reportDetails={reportDetails}
        />
    );
};
